/**
 * Country SEO i18n — Wave 14
 * New countries: Kuwait, Myanmar, Cambodia
 * Language gap fills: Italy, Netherlands, Portugal, Switzerland, Austria, Belgium
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE14: CountrySEOMap = {

  kuwait: {
    en: {
      title: 'Call Center Kuwait | Arabic Customer Service 24/7 | Call IT Dev',
      description: 'Call center for Kuwait: Arabic-native agents, AST timezone, CSAT 95%, from $4/hr. 55% savings. Islamic fintech support.',
      heroTitle: 'Call Center for Kuwait — Arabic-Native Support',
      heroSubtitle: 'Premium Arabic customer service for the Kuwaiti market from our Dubai MENA hub.',
    },
    fr: {
      title: 'Centre d\'appel Koweït | Service Client Arabophone | Call IT Dev',
      description: 'Centre d\'appel pour le Koweït : agents arabophones natifs, fuseau AST, dès 4 $/h. 55% d\'économies.',
      heroTitle: 'Centre d\'appel pour le Koweït — Support arabophone',
      heroSubtitle: 'Service client premium en arabe pour le marché koweïtien depuis notre hub MENA de Dubaï.',
    },
    ar: {
      title: 'مركز اتصال الكويت | خدمة عملاء بالعربية 24/7 | Call IT Dev',
      description: 'مركز اتصال للكويت: وكلاء ناطقون بالعربية، منطقة AST، CSAT 95%، من 4 $/ساعة. توفير 55%.',
      heroTitle: 'مركز اتصال للكويت — دعم بالعربية',
      heroSubtitle: 'خدمة عملاء متميزة بالعربية للسوق الكويتي من مركزنا في دبي.',
    },
    de: {
      title: 'Call Center Kuwait | Arabischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Kuwait: arabische Muttersprachler, AST-Zeitzone, ab 4 $/h. 55% Ersparnis.',
      heroTitle: 'Call Center für Kuwait — Arabischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Arabisch für den kuwaitischen Markt.',
    },
    es: {
      title: 'Call Center Kuwait | Atención al Cliente en Árabe | Call IT Dev',
      description: 'Call center para Kuwait: agentes arabófonos, zona AST, desde 4 $/h. 55% ahorro.',
      heroTitle: 'Call Center para Kuwait — Soporte en Árabe',
      heroSubtitle: 'Atención al cliente premium en árabe para el mercado kuwaití.',
    },
    zh: {
      title: '科威特呼叫中心 | 阿拉伯语客服外包 | Call IT Dev',
      description: '科威特呼叫中心：阿拉伯语母语座席，AST时区，从4美元/小时起。',
      heroTitle: '科威特呼叫中心 — 阿拉伯语支持',
      heroSubtitle: '以nearshore价格为科威特市场提供优质阿拉伯语客户服务。',
    },
    ja: {
      title: 'クウェートコールセンター | アラビア語カスタマーサポート | Call IT Dev',
      description: 'クウェート向けコールセンター：アラビア語ネイティブ、AST時間帯、4$/時間〜。',
      heroTitle: 'クウェートコールセンター — アラビア語サポート',
      heroSubtitle: 'ニアショア価格でクウェート市場向けプレミアムサポート。',
    },
    ko: {
      title: '쿠웨이트 콜센터 | 아랍어 고객 서비스 | Call IT Dev',
      description: '쿠웨이트 콜센터: 아랍어 원어민, AST 시간대, 시간당 4달러부터.',
      heroTitle: '쿠웨이트 콜센터 — 아랍어 지원',
      heroSubtitle: '니어쇼어 가격으로 쿠웨이트 시장 프리미엄 아랍어 고객 서비스.',
    },
  },

  italy: {
    zh: {
      title: '意大利呼叫中心 | 意大利语客服外包 | Call IT Dev',
      description: '意大利呼叫中心：意大利语母语座席，CET时区，CSAT 95%，从5美元/小时起。',
      heroTitle: '意大利呼叫中心 — 意大利语母语支持',
      heroSubtitle: '以nearshore价格提供优质意大利语客户服务。',
    },
    ja: {
      title: 'イタリアコールセンター | イタリア語カスタマーサポート | Call IT Dev',
      description: 'イタリア向けコールセンター：イタリア語ネイティブ、CET時間帯、5$/時間〜。',
      heroTitle: 'イタリアコールセンター — イタリア語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアムイタリア語顧客体験。',
    },
    ko: {
      title: '이탈리아 콜센터 | 이탈리아어 고객 서비스 | Call IT Dev',
      description: '이탈리아 콜센터: 이탈리아어 원어민, CET 시간대, 시간당 5달러부터.',
      heroTitle: '이탈리아 콜센터 — 이탈리아어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 이탈리아어 고객 경험.',
    },
    sv: {
      title: 'Callcenter Italien | Italienskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Italien: italiensktalande agenter, CET-tidszon, från 5 $/h.',
      heroTitle: 'Callcenter för Italien — Italienskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på italienska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Italien | Italiensksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Italien: italiensktalende agenter, CET-tidszone, fra 5 $/t.',
      heroTitle: 'Callcenter til Italien — Italiensksproget Support',
      heroSubtitle: 'Premium kundeservice på italiensk til nearshore-priser.',
    },
  },

  netherlands: {
    zh: {
      title: '荷兰呼叫中心 | 荷兰语客服外包 | Call IT Dev',
      description: '荷兰呼叫中心：荷兰语母语座席，CET时区，从6美元/小时起。',
      heroTitle: '荷兰呼叫中心 — 荷兰语支持',
      heroSubtitle: '以nearshore价格提供优质荷兰语客户服务。',
    },
    ja: {
      title: 'オランダコールセンター | オランダ語カスタマーサポート | Call IT Dev',
      description: 'オランダ向けコールセンター：オランダ語ネイティブ、CET時間帯、6$/時間〜。',
      heroTitle: 'オランダコールセンター — オランダ語サポート',
      heroSubtitle: 'ニアショア価格でプレミアムオランダ語顧客体験。',
    },
    ko: {
      title: '네덜란드 콜센터 | 네덜란드어 고객 서비스 | Call IT Dev',
      description: '네덜란드 콜센터: 네덜란드어 원어민, CET 시간대, 시간당 6달러부터.',
      heroTitle: '네덜란드 콜센터 — 네덜란드어 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 네덜란드어 고객 경험.',
    },
    sv: {
      title: 'Callcenter Nederländerna | Nederländskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Nederländerna: nederländsktalande agenter, CET, från 6 $/h.',
      heroTitle: 'Callcenter för Nederländerna — Nederländskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på nederländska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Holland | Nederlandsksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Holland: nederlandsktalende agenter, CET, fra 6 $/t.',
      heroTitle: 'Callcenter til Holland — Nederlandsksproget Support',
      heroSubtitle: 'Premium kundeservice på nederlandsk til nearshore-priser.',
    },
  },

  portugal: {
    zh: {
      title: '葡萄牙呼叫中心 | 葡萄牙语客服外包 | Call IT Dev',
      description: '葡萄牙呼叫中心：葡萄牙语母语座席，WET时区，从4美元/小时起。',
      heroTitle: '葡萄牙呼叫中心 — 葡萄牙语支持',
      heroSubtitle: '以nearshore价格提供优质葡萄牙语客户服务。',
    },
    ja: {
      title: 'ポルトガルコールセンター | ポルトガル語カスタマーサポート | Call IT Dev',
      description: 'ポルトガル向けコールセンター：ポルトガル語ネイティブ、WET時間帯、4$/時間〜。',
      heroTitle: 'ポルトガルコールセンター — ポルトガル語サポート',
      heroSubtitle: 'ニアショア価格でプレミアムポルトガル語顧客体験。',
    },
    ko: {
      title: '포르투갈 콜센터 | 포르투갈어 고객 서비스 | Call IT Dev',
      description: '포르투갈 콜센터: 포르투갈어 원어민, WET 시간대, 시간당 4달러부터.',
      heroTitle: '포르투갈 콜센터 — 포르투갈어 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 포르투갈어 고객 경험.',
    },
    sv: {
      title: 'Callcenter Portugal | Portugisiskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Portugal: portugisisktalande agenter, WET-tidszon, från 4 $/h.',
      heroTitle: 'Callcenter för Portugal — Portugisiskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på portugisiska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Portugal | Portugisisksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Portugal: portugisisktalende agenter, WET-tidszone, fra 4 $/t.',
      heroTitle: 'Callcenter til Portugal — Portugisisksproget Support',
      heroSubtitle: 'Premium kundeservice på portugisisk til nearshore-priser.',
    },
  },

  switzerland: {
    zh: {
      title: '瑞士呼叫中心 | 多语言客服外包 | Call IT Dev',
      description: '瑞士呼叫中心：德语/法语/意大利语三语座席，CET时区，从8美元/小时起。',
      heroTitle: '瑞士呼叫中心 — 三语支持',
      heroSubtitle: '以nearshore价格为瑞士市场提供三语客户服务。',
    },
    ja: {
      title: 'スイスコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'スイス向けコールセンター：独/仏/伊トリリンガル、CET時間帯、8$/時間〜。',
      heroTitle: 'スイスコールセンター — トリリンガルサポート',
      heroSubtitle: 'ニアショア価格でスイス市場向けプレミアム多言語サポート。',
    },
    ko: {
      title: '스위스 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '스위스 콜센터: 독일어/프랑스어/이탈리아어, CET 시간대, 시간당 8달러부터.',
      heroTitle: '스위스 콜센터 — 삼개국어 지원',
      heroSubtitle: '니어쇼어 가격으로 스위스 시장 프리미엄 다국어 고객 서비스.',
    },
  },

  austria: {
    zh: {
      title: '奥地利呼叫中心 | 德语客服外包 | Call IT Dev',
      description: '奥地利呼叫中心：德语母语座席，CET时区，从6美元/小时起。',
      heroTitle: '奥地利呼叫中心 — 德语支持',
      heroSubtitle: '以nearshore价格提供优质德语客户服务。',
    },
    ja: {
      title: 'オーストリアコールセンター | ドイツ語カスタマーサポート | Call IT Dev',
      description: 'オーストリア向けコールセンター：ドイツ語ネイティブ、CET時間帯、6$/時間〜。',
      heroTitle: 'オーストリアコールセンター — ドイツ語サポート',
      heroSubtitle: 'ニアショア価格でプレミアムドイツ語顧客体験。',
    },
    ko: {
      title: '오스트리아 콜센터 | 독일어 고객 서비스 | Call IT Dev',
      description: '오스트리아 콜센터: 독일어 원어민, CET 시간대, 시간당 6달러부터.',
      heroTitle: '오스트리아 콜센터 — 독일어 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 독일어 고객 경험.',
    },
    sv: {
      title: 'Callcenter Österrike | Tyskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Österrike: tysktalande agenter, CET-tidszon, från 6 $/h.',
      heroTitle: 'Callcenter för Österrike — Tyskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på tyska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Østrig | Tysksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Østrig: tysktalende agenter, CET-tidszone, fra 6 $/t.',
      heroTitle: 'Callcenter til Østrig — Tysksproget Support',
      heroSubtitle: 'Premium kundeservice på tysk til nearshore-priser.',
    },
  },

  belgium: {
    zh: {
      title: '比利时呼叫中心 | 多语言客服外包 | Call IT Dev',
      description: '比利时呼叫中心：法语/荷兰语/英语三语座席，CET时区，从5美元/小时起。',
      heroTitle: '比利时呼叫中心 — 三语支持',
      heroSubtitle: '以nearshore价格为比利时市场提供三语客户服务。',
    },
    ja: {
      title: 'ベルギーコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'ベルギー向けコールセンター：仏語/蘭語/英語、CET時間帯、5$/時間〜。',
      heroTitle: 'ベルギーコールセンター — トリリンガルサポート',
      heroSubtitle: 'ニアショア価格でベルギー市場向けプレミアム多言語サポート。',
    },
    ko: {
      title: '벨기에 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '벨기에 콜센터: 프랑스어/네덜란드어/영어, CET 시간대, 시간당 5달러부터.',
      heroTitle: '벨기에 콜센터 — 삼개국어 지원',
      heroSubtitle: '니어쇼어 가격으로 벨기에 시장 프리미엄 다국어 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Belgien | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Belgien: franska/nederländska/engelska, CET, från 5 $/h.',
      heroTitle: 'Callcenter för Belgien — Flerspråkigt Stöd',
      heroSubtitle: 'Premium flerspråkig kundtjänst för den belgiska marknaden.',
    },
    da: {
      title: 'Callcenter Belgien | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Belgien: fransk/nederlandsk/engelsk, CET, fra 5 $/t.',
      heroTitle: 'Callcenter til Belgien — Flersproget Support',
      heroSubtitle: 'Premium flersproget kundeservice til det belgiske marked.',
    },
  },
};
